import { AngularFirestore } from 'angularfire2/firestore';
import { DataModel, IDataModel } from './data.model'
import { Analytics }  from './analytics.model';
import { UsersService } from './usuarios.service';

export interface IFavoritos extends IDataModel {
    fornecedor?:number,
    codigo?: string,
    gostou?: number,
}

export class Favoritos extends DataModel<IFavoritos>  {
    constructor(private db: AngularFirestore) {
        super(db,'analyticsFavoritos');
    }

addFavorito(fornecedor:number,codigo:string,gostou:number){
    let it:IFavoritos={};
    it.fornecedor = fornecedor;
    it.codigo = codigo;
    it.gostou = gostou;
    this.add(it);
}

}
